export default __webpack_public_path__ + "static/media/asset-pic.6fe8a73f.png";